import { createContext, ReactElement, ReactNode, useContext } from 'react'
import { matchPath, useLocation } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization/userOrganizationContext'

import { getOrganizationViewUrl } from '../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../utils/routing/reactRoute'

type VatDeclarationsRoutes = typeof reactRoute.organization.vatDeclarations

const VatDeclarationsRouteContext = createContext<VatDeclarationsRoutes | undefined>(undefined)

export const useVatDeclarationsRoutes = (): VatDeclarationsRoutes => {
  const context = useContext(VatDeclarationsRouteContext)

  if (!context) {
    throw new Error('VatDeclarationsRouteProvider is missing in the module!')
  }

  return context
}

interface VatDeclarationsRouteProviderProps {
  children?: ReactNode
}

export const VatDeclarationsRouteProvider = ({ children }: VatDeclarationsRouteProviderProps): ReactElement => {
  const { pathname } = useLocation()
  const { organization } = useUserOrganization()

  const expertMainRoute = getOrganizationViewUrl(
    organization?.url,
    reactRoute.organization.expertVatDeclarations.getMainRoute(),
  )
  const isExpertRoute = Boolean(matchPath({ path: expertMainRoute, end: false }, pathname))

  return (
    <VatDeclarationsRouteContext.Provider
      value={isExpertRoute ? reactRoute.organization.expertVatDeclarations : reactRoute.organization.vatDeclarations}
    >
      {children}
    </VatDeclarationsRouteContext.Provider>
  )
}
